import React from "react";
import {Navbar, Nav, Form, Button} from "react-bootstrap";
import { LinkContainer, IndexLinkContainer } from "react-router-bootstrap";
import { RouteChildrenProps } from "react-router";
import { Role } from "../firestore";
import AppUser from "../AppUser";

const HAYASHI_JUNYAKU = "http://www.hpc-j.co.jp/";

interface Props extends RouteChildrenProps {
    user: AppUser
}

export default class NavBar extends React.Component<Props, {}>{
    render() {
        return (
            <Navbar bg="primary" expand="lg" variant="dark">
                {this.props.user.role === Role.Customer &&
                    <Navbar.Brand>AQ Scope Soil</Navbar.Brand>
                }
                {this.props.user.role === Role.Demo &&
                    <Navbar.Brand>AQ Scope Soil デモ用</Navbar.Brand>
                }
                {this.props.user.role === Role.Admin &&
                        <Navbar.Brand>AQ Scope Soil 管理者用</Navbar.Brand>
                }
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse>
                    <Nav className="mr-auto">
                        <IndexLinkContainer to="/">
                            <Nav.Link>トップ</Nav.Link>
                        </IndexLinkContainer>
                        {this.props.user.role === Role.Customer &&
                            <LinkContainer to="/data-list">
                                <Nav.Link>データ一覧</Nav.Link>
                            </LinkContainer>
                        }
                        {this.props.user.role === Role.Customer &&
                            <LinkContainer to="/warranty-list">
                                <Nav.Link>保証書ダウンロード</Nav.Link>
                            </LinkContainer>
                        }
                        {this.props.user.role === Role.Demo &&
                            <LinkContainer to="/data-list">
                                <Nav.Link>データ一覧</Nav.Link>
                            </LinkContainer>
                        }
                        {this.props.user.role === Role.Demo &&
                            <LinkContainer to="/warranty-list">
                                <Nav.Link>保証書ダウンロード</Nav.Link>
                            </LinkContainer>
                        }
                        {this.props.user.role === Role.Admin &&
                            <LinkContainer to="/admin-data-list">
                                <Nav.Link>全ユーザデータ一覧</Nav.Link>
                            </LinkContainer>
                        }
                        {this.props.user.role === Role.Admin &&
                            <LinkContainer to="/device-maint_navi">
                                <Nav.Link>機器情報メンテ</Nav.Link>
                            </LinkContainer>
                        }
                        {this.props.user.role === Role.Demo &&
                         this.props.user.name === "デモデータ作成用" &&
                            <LinkContainer to="/demo-tool">
                                <Nav.Link>ツール</Nav.Link>
                            </LinkContainer>
                        }
                    </Nav>
                    <Form inline>
                        {this.props.user.role !== Role.Admin &&
                            <Button variant="outline-light" onClick={async () => {window.open(HAYASHI_JUNYAKU,"_blank")}}>消耗品の注文(林純薬)</Button>
                        }
                        <LinkContainer to="/logout">
                            <Button variant="outline-light">ログアウト</Button>
                        </LinkContainer>
                    </Form>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}
